/**
 * Limit lat/lng to 3 decimal
 *
 * @param {*} latLng
 * @returns {number|null}
 */
fixLatOrLng = function (latLng) {
  if (typeof latLng === 'string') {
    latLng = parseFloat(latLng);
  }

  if (typeof latLng === 'number' && !isNaN(latLng)) {
    return parseFloat(latLng.toFixed(3));
  }

  return null
};

exports.fixLatOrLng = fixLatOrLng;
